import { useApi } from '@hooks/useApi';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { MerchantUser } from '@root/globalTypes';

type GetUsersReturn = {
  data: MerchantUser[];
  isPending: boolean;
};

export function useListUsers(): GetUsersReturn {
  const { query } = useApi();

  const { data, isPending } = useQuery<MerchantUser[]>({
    queryKey: [...queryKeys.merchantUsers, window.location.search],
    queryFn: (): Promise<MerchantUser[]> =>
      query({
        path: `v1/merchant/users${window.location.search}`,
      }),
  });

  return {
    data: data || [],
    isPending,
  };
}
